import { PayloadAction } from '@reduxjs/toolkit'
import { EReportFilterOperations } from '@unfoldrtech/portal-mic/dist/src/models/core'
import { TReportingFilters } from '@unfoldrtech/portal-mic/dist/src/models/types'

const setFilterOperation = (
  state: TReportingFilters,
  action: PayloadAction<{
    filterOperation?: EReportFilterOperations
  }>
) => {
  state.filterOperation = action.payload
    .filterOperation as TReportingFilters['filterOperation']
}

export default setFilterOperation
